var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_641_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H52C58.6274 0 64 5.37258 64 12V52C64 58.6274 58.6274 64 52 64H12C5.37258 64 0 58.6274 0 52V12Z",
    fill: "#F1F4F7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4343 57.7129C33.6907 57.9222 34.8944 55.9265 36.7585 54.1473C38.2446 52.45 39.8474 51 39.8474 51L25.1866 51C25.1866 51 27.1137 52.4107 28.6781 54.3181C29.3266 55.1088 30.1324 55.9281 30.7266 56.6216C31.2855 57.2739 31.8253 57.6115 32.4343 57.7129Z",
    fill: "#FF715B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5C17 11.9101 19.9101 9 23.5 9H42C45.3137 9 48 11.6863 48 15V15.5C48 19.0899 45.0899 22 41.5 22H23.5C19.9101 22 17 19.0899 17 15.5Z",
    fill: "#A09DFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H48V37H17V15Z",
    fill: "#A09DFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43.5C51 40.7152 49.8938 38.0445 47.9246 36.0754C45.9555 34.1062 43.2848 33 40.5 33C37.7152 33 35.0445 34.1062 33.0754 36.0754C31.1062 38.0445 30 40.7152 30 43.5L40.5 43.5H51Z",
    fill: "#F1F4F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8719 44.9094C42.227 43.927 41.7223 42.9515 41.1988 42.6856C40.5571 42.7138 39.5123 43.2658 39.1572 44.2482C38.8021 45.2306 39.2483 46.2233 39.83 46.4727C40.5689 46.4219 41.5168 45.8919 41.8719 44.9094Z",
    fill: "#FB6DC3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5C17 11.9101 19.9101 9 23.5 9H32.5V37H17V15.5Z",
    fill: "#BFBDFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43.5C35 40.7152 33.8938 38.0445 31.9246 36.0754C29.9555 34.1062 27.2848 33 24.5 33C21.7152 33 19.0445 34.1062 17.0754 36.0754C15.1062 38.0445 14 40.7152 14 43.5L24.5 43.5H35Z",
    fill: "#F1F4F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.133 44.8513C22.7779 43.8689 23.2826 42.8934 23.8061 42.6275C24.4478 42.6557 25.4926 43.2076 25.8477 44.1901C26.2028 45.1725 25.7566 46.1652 25.1749 46.4146C24.436 46.3638 23.4881 45.8337 23.133 44.8513Z",
    fill: "#FB6DC3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2941 43.7099C34.3045 42.305 33.2597 41.1828 32.4999 40.9997C31.7223 41.2409 30.676 42.2991 30.6656 43.7039C30.6552 45.1088 31.6354 46.2722 32.4598 46.4151C33.3471 46.1133 34.2837 45.1147 34.2941 43.7099Z",
    fill: "#FB6DC3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_641_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H52C58.6274 0 64 5.37258 64 12V52C64 58.6274 58.6274 64 52 64H12C5.37258 64 0 58.6274 0 52V12Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6375 53.3646C19.5516 54.2516 21.677 53.2952 24.2223 52.8927C26.4101 52.3425 28.5532 52.062 28.5532 52.062L16.4967 43.7205C16.4967 43.7205 17.2789 45.977 17.4801 48.4356C17.5635 49.4548 17.76 50.5872 17.8541 51.4955C17.9425 52.3499 18.1944 52.9347 18.6375 53.3646Z",
    fill: "#FF715B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9628 9.86876C32.0053 6.91662 36.0543 6.17923 39.0065 8.22175L54.2201 18.7477C56.9451 20.6331 57.6258 24.3706 55.7404 27.0957L55.4559 27.5069C53.4134 30.459 49.3644 31.1964 46.4123 29.1539L31.6098 18.9124C28.6577 16.8699 27.9203 12.8209 29.9628 9.86876Z",
    fill: "#A09DFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.248 9.45752L55.7411 27.0956L43.2237 45.1875L17.7307 27.5494L30.248 9.45752Z",
    fill: "#A09DFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9916 52.2399C43.576 49.9498 44.1859 47.1241 43.6869 44.3844C43.188 41.6447 41.6211 39.2154 39.331 37.6309C37.041 36.0465 34.2153 35.4367 31.4755 35.9356C28.7358 36.4346 26.3065 38.0014 24.7221 40.2915L33.3568 46.2657L41.9916 52.2399Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6833 48.205C34.5343 47.5992 34.6743 46.5098 34.3951 45.9933C33.8513 45.6513 32.678 45.5108 31.827 46.1167C30.976 46.7226 30.7781 47.7927 31.1147 48.3288C31.7511 48.7075 32.8323 48.8109 33.6833 48.205Z",
    fill: "#FB6DC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9628 9.86876C32.0053 6.91662 36.0543 6.17923 39.0065 8.22175L46.4077 13.3425L30.4765 36.3685L17.7299 27.5494L29.9628 9.86876Z",
    fill: "#BFBDFD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8344 43.1359C30.4188 40.8458 31.0286 38.0201 30.5297 35.2804C30.0308 32.5407 28.4639 30.1114 26.1738 28.5269C23.8837 26.9425 21.058 26.3326 18.3183 26.8316C15.5786 27.3305 13.1493 28.8974 11.5649 31.1875L20.1996 37.1617L28.8344 43.1359Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3063 37.4956C18.5733 36.4856 19.5434 35.9706 20.1252 36.0498C20.6369 36.4381 21.182 37.4865 20.915 38.4964C20.6481 39.5064 19.7164 40.0688 19.096 39.9429C18.5173 39.4808 18.0394 38.5055 18.3063 37.4956Z",
    fill: "#FB6DC3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1346 42.9069C28.9425 41.7576 28.7218 40.2403 28.2012 39.6574C27.4244 39.4133 25.962 39.6882 25.1541 40.8376C24.3462 41.9869 24.4903 43.5014 25.087 44.0879C25.9884 44.3446 27.3267 44.0563 28.1346 42.9069Z",
    fill: "#FB6DC3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_641_17",
    x: 0,
    y: 0,
    width: 64,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.878431 0 0 0 0 0.988235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_641_17"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_641_17",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.615686 0 0 0 0 0.980392 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_17",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.4615c3580deaf20ea867578c37efaab8.svg";
export { ForwardRef as ReactComponent };